export enum ERatingType {    
    Forecast,
    Current
}